// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"8eba475f","75":"d999e81d","605":"a1788848","739":"2a2ea9d2"}[chunkId] + ".css";
};